import { PersistentSharedState } from '@trello/shared-state';

export const developerConsoleState = new PersistentSharedState<{
  lastActiveTab: number;
  developerConsoleOpen: boolean;
  developerConsoleEnabled: boolean;
}>(
  {
    lastActiveTab: 0,
    developerConsoleOpen: false,
    developerConsoleEnabled: false,
  },
  {
    storageKey: 'developerConsoleState',
  },
);
